import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormRichText from '../../../../library/form/components/FormRichText'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import FormSH from '../../../../library/form/components/FormSH';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const VoucherHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '790px', height: '500px' }}
            contentStyle={{ height: '400px', overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >
        <div  className="uiEditableContent" id="editor">
            <div className="uiRow">
                <div className="uiCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{
                                    InputType: "ac", actionId:"refresh", paramName: "profile", acMethod: "ProfileName", actionParam:{ updateOutstanding: "1" },
                                    acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 }
                                }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "billFromDate" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billFromDate" }} value="Bill From Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "dp", paramName: "billFromDate" }} />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "billToDate" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billToDate" }} value="Bill To Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "dp", paramName: "billToDate" }} />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "paymentMode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                            <FormSH formObject={formObject} rowKey=""
                                action={{ actionId: "new", paramName: "paymentMode",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentDtl" }} value="Payment Detail" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "paymentDtl" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargeType" }} value="Charge Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey=""  className="uiInput"
                                action={{
                                    InputType: "ac", paramName: "chargeType", actionId:"refresh", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' },
                                    actionParam: { updateOutstanding: "1" }
                                }}
                            />
                            <FormSH formObject={formObject} rowKey="" 
                                action={{ actionId: "new", paramName: "chargeType",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargePercent" }} value="Charge %" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", actionId:"refresh", paramName: "chargePercent", actionParam: { updateOutstanding: "1" } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNumber" }} value="Reference Number" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "refNumber" }} />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "journalName" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "journalName" }} value="Journal Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "journalName", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </FormWrapper>
                    </ul>
                </div>
                <div className="uiCol">
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "voucherDate" }} value="Voucher Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "dp", paramName: "voucherDate" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                            </span>
                            <FormInput formObject={formObject} rowKey=""  className="uiInput"
                                action={{
                                    InputType: "ac", paramName: "currency", actionId:"refresh", acMethod: "CurrencyName", acDepCtrl: {},
                                    actionParam: { updateOutstanding: "1" }
                                }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exRate" }} value="Exchange Rate" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", actionId:"refresh", paramName: "exRate", actionParam: { updateOutstanding: "1" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "voucherAmt" }} value="Amount Paid" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", actionId:"refresh", paramName: "voucherAmt", actionParam: { updateOutstanding: "1" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxDeducted" }} value="Tax Deducted" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "taxDeducted" }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtToAdjust" }} value="Amount to Adjust" />
                            </span>
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "amtToAdjust" }} className="uiVal" />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargeAmount" }} value="Charge Amount" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", actionId:"refresh", paramName: "chargeAmount", actionParam: { updateOutstanding: "1" } }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} >
                            <span className='uiRed'>
                                <SarasTrans value="Budget Code and Cost Center is Required if Charge Amount > 0" />
                            </span>
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budgetCode" }} value="Budget Code" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "budgetCode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "costCenter" }} value="Cost Center" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "costCenter", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </FormWrapper>
                    </ul>
                </div>
            </div>
            <div className="uiRow">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                </span>
                <FormRichText formObject={formObject} rowKey="" rows="5" cols="71" className="uiFrmText"
                    action={{ paramName: "remarks" }}
                />
            </div>

            <div className="uiRow" ID="outstandingAmtDateEditor" >
                <div className="uiColumn uiROHeader uiSpacer15">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} value="Last Paid Date" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} />
                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalOutstanding" }} value="Outstanding" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalOutstanding" }} />
                </div>
            </div>
        </div>
        </FormDialog>
    )
}

export default withView(VoucherHeaderEditor, "voucherHead", "voucherHead,voucherDetail,voucherFooter")